import { MAX_WIDTH, MIN_WIDTH, ROOT_FONT_SIZE } from './constants';

export const pxToRem = (px: number, rootFontSize: number = ROOT_FONT_SIZE): string => `${px / rootFontSize}rem`;

export const createFluidTypography = (
  minFontSize: number,
  maxFontSize: number,
  minVw: number = MIN_WIDTH,
  maxVw: number = MAX_WIDTH
): { fontSize: string } => ({
  fontSize: `${minFontSize}px`,
  [`@media screen and (min-width: ${minVw}px)`]: {
    fontSize: `calc(${minFontSize}px + ${maxFontSize - minFontSize} * ((100vw - ${minVw}px) / ${maxVw - minVw}))`,
  },
  [`@media screen and (min-width: ${maxVw}px)`]: {
    fontSize: `${maxFontSize}px`,
  },
});
